<template>
  <div class="live">
    <div class="left">
      <div class="top">
        <easy-player id="player"></easy-player>
      </div>
      <div class="bottom">
        {{$t('terminal.CurrentStreamAddress')}}<el-input  class="input" v-model="input"  id="input"  :disabled="true"></el-input>
        <el-button @click="copyInput">{{$t('terminal.buttonCopy')}}</el-button>
      </div>
    </div>
    <div class="right">
      <h1>{{$t('terminal.setParameters')}}</h1>
      <ul>
        <li>
          <el-switch v-model="this.from.check"></el-switch>{{$t('terminal.tips1')}}
        </li>
        <li>
          <span>{{$t('terminal.Resolution')}}</span>
          <el-select v-model="this.from.resolution" placeholder="this.from.resolution">
            <el-option
                v-for="item in this.resolution"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </li>
        <li>
          <span>{{$t('terminal.FrameRate')}}</span>
          <el-select v-model="this.from.rate" placeholder="this.from.rate">
            <el-option
                v-for="item in this.rate"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "live",
  data(){
    return{
      player:null,
      liveId:null,
      input:null,
      from:{
        check:true,
        resolution:'720P',//分辨率
        rate:'30',//帧率
      },
      resolution:[{
        value:'选项1',
        label:"720P"
      },{
        value:'选项2',
        label:"1080P"
      }],
      rate:[{
        value:'选项1',
        label:"30"
      },{
        value:'选项2',
        label:"60"
      }],//码率
    }
  },
  methods:{
    //播放
    onPlay(url){
      this.player.setAttribute('is-h265', true);            // 强制H265解码
      this.player.setAttribute('speed', true);              //是否开启流畅模式，默认false关闭
      this.player.setAttribute('live', true);               //是否为直播
      this.player.setAttribute('video-url', url);
    },
    // 停止
    onStop(){
      this.player.setAttribute('video-url','')
    },
    //复制input内容
    copyInput(){
      const inputElement = document.getElementById('input')
      inputElement.select(); // 选中输入框内容
      document.execCommand('copy'); // 执行复制操作
      this.$message.success('复制成功');
    }
  },
  mounted() {
    this.$nextTick(()=>{
      this.liveId = sessionStorage.getItem("liveId");
      this.player = document.getElementById("player")
      this.input = "rtmp://" + window.location.hostname + ":19935/live/" + this.liveId;
      this.onPlay(this.input);
    })
  },
}
</script>
<style lang="scss" scoped>
.live {
  width: 100%;
  height: calc(100% - 80px);
  display: flex;
  .left {
    flex: 7;
    display: flex;
    flex-direction: column;
    border-right: 10px solid #edfbff;
    .top {
      flex: 8;
      display: flex;
      justify-content: center;
      align-items: center;
      #player{
        width: 80%;
        height: 80%;
      }
    }

    .bottom {
      flex: 2;
      display: flex;
      justify-content: center;
      align-items: center;
      .el-input{
        width: 60%;
      }
      .el-button{
        margin-left: 5%;
      }
    }
  }
  .right {
    flex: 3;
    h1{
      height: 10%;
      font-size: 25px;
    }
    ul{
      margin-left: 10%;
      li{
        margin-top: 5%;
      }
    }
  }
}
</style>
